module.exports = "/lucky-balls/img/blue-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/blue-ball.png
// module id = 95
// module chunks = 0